import React from 'react'
import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete'
import { FormHelperText, TextField } from '@mui/material'

import useStyles from './styles'

const filter = createFilterOptions()

function handleFilterOptions(options, params) {
  const filtered = filter(options, params)

  if (params.inputValue !== '') {
    filtered.push({
      inputValue: params.inputValue,
      label: `Adicionar "${params.inputValue}"`,
    })
  }

  return filtered
}

function getLabel(option) {
  if (typeof option === 'string') return option
  if (option.inputValue) return option.inputValue
  return option.label
}

function renderCustomOption(option) {
  return option.label
}

/**
 * @param {{
 *  value: string | object,
 *  options: any[],
 *  onChange?: (val: any) => void,
 *  label?: string,
 *  style?: React.CSSProperties,
 *  variant?: 'outlined' | 'filled' | 'standard'
 * }} props
 */

export function AutocompleteV2({
  value,
  onChange,
  label = '',
  style = {},
  options = [],
  placeholder = '',
  variant = 'outlined',
  required = false,
  error = '',
  ...props
}) {
  const styles = useStyles()
  function renderCustomInput(params) {
    return (
      <TextField
        {...params}
        label={label}
        variant={variant}
        placeholder={placeholder}
        required={required}
        error={!!error}
        InputProps={{
          ...params.InputProps,
          style: {
            fontSize: '14px',
          },
        }}
      />
    )
  }

  const handleChange = (event, newValue) => {
    if (typeof newValue === 'string') {
      onChange?.({ label: newValue })
    } else if (newValue && newValue.inputValue) {
      onChange?.({ label: newValue.inputValue })
    } else {
      onChange?.(newValue)
    }
  }

  return (
    <>
      <Autocomplete
        value={value}
        selectOnFocus
        options={options}
        handleHomeEndKeys
        onChange={handleChange}
        getOptionLabel={getLabel}
        style={{ width: 300, ...style }}
        renderOption={renderCustomOption}
        filterOptions={handleFilterOptions}
        renderInput={params => renderCustomInput(params, label)}
        getOptionSelected={(option, selectedValue) => option.label === selectedValue.label}
        noOptionsText="Nenhuma opção encontrada"
        {...props}
      />
      {!!error && (
        <FormHelperText className={styles.errorMessage} error={!!error}>
          {error}
        </FormHelperText>
      )}
    </>
  )
}
